export default __webpack_public_path__ + "static/media/logo2.5eb01d59.svg";